/* eslint-disable no-unused-vars */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import 'regenerator-runtime/runtime'
import {
  getAuth,
  signInWithRedirect,
  OAuthProvider,
  updatePassword,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCS5yZIkcFNMKxh0i8rwZurMqSDfsfVbVQ",
  authDomain: "collider.social",
  projectId: "collider-web",
  storageBucket: "collider-web.appspot.com",
  messagingSenderId: "585906902456",
  appId: "1:585906902456:web:21a956aada6c09ed8beb4d",
  measurementId: "G-7SS9KCJWJD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();


const provider = new OAuthProvider("microsoft.com");

provider.setCustomParameters({
  tenant: "9f119962-8c62-431c-a8ef-e7e0a42d11fc",
});

let passwordButton = document.getElementById("change-password");
let signupButton = document.getElementById("sign-up-button");
let closeFormButton = document.getElementById("close-form-button");
let displayName = "";
let congrats = document.getElementById("congrats");
let lilCongrats = document.getElementById("lil-congrats");


setPersistence(auth, browserLocalPersistence);

document.getElementById("loader-wrapper").style.display = "none";

function displayLoader(){
  document.getElementById("loader-wrapper").style.display = "flex";
}
function hideLoader(){
  document.getElementById("loader-wrapper").style.display = "none";
}

function signInWithUSFQ() {
  displayLoader()
  const provider = new OAuthProvider("microsoft.com");

  provider.setCustomParameters({
    tenant: "9f119962-8c62-431c-a8ef-e7e0a42d11fc",
  });

  signInWithRedirect(auth, provider)
    .then((result) => {
      const credential = OAuthProvider.credentialFromResult(result);
      const accessToken = credential.accessToken;
      const idToken = credential.idToken;

    })
    .catch((error) => {
      console.log(error);
    });
}

signupButton.addEventListener("click", () => {
  signInWithUSFQ();
});




onAuthStateChanged(auth, async (user) => {
  if (user) {
    window.scrollTo({top: 0, behavior: "smooth"});
    congrats.innerHTML = "Felicidades " + user.displayName.split(" ")[0];
    lilCongrats.innerHTML =
      "Ahora eres parte de uno de los experimentos sociales más grandes de la universidad. <br/> Pronto recibirás un correo con más información. <br/> <br/>  Feb. 2024";
    signupButton.style.display = "none";
    hideLoader();
    console.log("Logged in ", user);
  } else {
    console.log("Logged out");
  }
});